
import { useNavigate } from "react-router-dom";
import { VenueRecommendation, DateRecommendation } from "./types";

export const useEventCard = (
  eventId: string,
  status: string,
  event_venue_recommendations: VenueRecommendation[] = [],
  event_date_recommendations: DateRecommendation[] = [],
  recommendations = { venues: { total: 0, selected: 0 }, dates: { total: 0, selected: 0 } }
) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/events/${eventId}`);
  };

  // Get selected venue and date if status is confirmed or booked
  const selectedVenue = status === 'confirmed' || status === 'booked' 
    ? event_venue_recommendations.find(rec => rec.is_selected)?.venue
    : null;

  const selectedDate = status === 'confirmed' || status === 'booked'
    ? event_date_recommendations.find(rec => rec.is_selected)?.recommended_date
    : null;

  return {
    handleCardClick,
    selectedVenue,
    selectedDate,
  };
};
